// src/entities/authorComposer/components/common/AuthorStatusPanel.tsx
import React from "react";
import { observer } from "mobx-react";
import { Box } from "@mui/material";
import { useRootStore } from "../../../../store/contexts";
import { tieneDatosValidados, useEstadoAutor } from "./authorStatus";
import { AuthorDniBadge } from "./AuthorDniBadge";
import { AuthorDocumentationWarning, avisosDeDocumentacion } from "./AuthorDocumentationWarning";

/**
 * Arriba de la vista y del formulario de edición: validado con DNI y advertencias.
 *
 * Está siempre, también antes de que llegue el estado y sin nada que decir: la
 * región de la advertencia (role="status") tiene que existir antes que su texto
 * para que un lector de pantalla lo anuncie. Vacío no ocupa lugar: sin margen,
 * y sin separación entre la marca y una región vacía.
 */
export const AuthorStatusPanel: React.FC<{ recordId: string }> = observer(({ recordId }) => {
  const { langStore } = useRootStore();
  const estado = useEstadoAutor(recordId);
  const validado = tieneDatosValidados(estado);
  const conAvisos = avisosDeDocumentacion(estado, langStore).length > 0;
  return (
    <Box
      sx={
        validado || conAvisos
          ? {
              mb: 2,
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              gap: validado && conAvisos ? 1 : 0,
            }
          : undefined
      }
    >
      <AuthorDniBadge estado={estado} />
      <AuthorDocumentationWarning estado={estado} />
    </Box>
  );
});
